/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Auth_Error_DescriptionInputs */

const es_login_auth_error_description = /** @type {(inputs: Login_Auth_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubo un problema al autenticarte. Por favor, intentá de nuevo.`)
};

const en_login_auth_error_description = /** @type {(inputs: Login_Auth_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong during authentication. Please try again.`)
};

/**
* | output |
* | --- |
* | "Something went wrong during authentication. Please try again." |
*
* @param {Login_Auth_Error_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const login_auth_error_description = /** @type {((inputs?: Login_Auth_Error_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Auth_Error_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_login_auth_error_description(inputs)
	return en_login_auth_error_description(inputs)
});
export { login_auth_error_description as "login.auth_error.description" }